import {
  COLORS,
  COMMON_STYLES,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from '@dehaat/dds'
import React from 'react'
import {
  Pressable,
  View,
  Text,
  StyleSheet,
  StyleProp,
  ViewStyle,
} from 'react-native'

const AddProductsButton = ({
  style,
  onClick,
}: {
  style?: StyleProp<ViewStyle>
  onClick: () => void
}) => (
  <View style={[COMMON_STYLES.justifyCenter, style]}>
    <Pressable
      onPress={onClick}
      style={({ pressed }) => [
        pressed && COMMON_STYLES['opacity1/2'],
        COMMON_STYLES.alignItemsCenter,
      ]}
    >
      <View style={[styles.addCropBtn, styles.img84X84]}>
        <Text
          style={[
            TYPOGRAPHY.HEADING1,
            VARIANTS_STYLES.EMPHASIZED,
            TEXT_STYLES.textPrimary100,
          ]}
        >
          +
        </Text>
      </View>
      <Text
        style={[
          TYPOGRAPHY.TEXT1,
          VARIANTS_STYLES.MEDIUM,
          TEXT_STYLES.textNeutral80,
          COMMON_STYLES['mt1/2'],
        ]}
      >
        Add Products
      </Text>
    </Pressable>
  </View>
)

export default AddProductsButton

const styles = StyleSheet.create({
  addCropBtn: {
    borderWidth: 1,
    borderColor: COLORS.primary100,
    backgroundColor: COLORS.primary20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  img84X84: {
    height: 84,
    width: 84,
    borderRadius: 16,
  },
})
